export default __webpack_public_path__ + "static/media/4.b272e7f1.jpg";